module.exports = __webpack_public_path__ + "img/DE00567.93f9601a.png";